import {analyticsLogger} from 'analytics/analyticsLogger';
import {getNavigationContext} from 'analytics/navigationInfo';
import {getAnonymizedRoute} from 'analytics/routeInfo';
import {clearExpiredSession} from 'atoms/auth';
import axios, {AxiosError} from 'axios';

type ErrorBody = {detail?: unknown};

export const handleUnauthenticatedResponse = (status?: number, body?: ErrorBody) => {
  if (status === 401) {
    const isUserDeactivated = body?.detail === 'User is deactivated';
    analyticsLogger().logEvent('AUTH_SESSION_EXPIRED', {
      route: getAnonymizedRoute(),
      redirect_target: isUserDeactivated ? 'waitlist' : 'login',
      ...getNavigationContext(),
    });
    clearExpiredSession(isUserDeactivated);
  }
};

export const installSessionExpiryHandler = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError<ErrorBody>) => {
      handleUnauthenticatedResponse(error.response?.status, error.response?.data);
      return Promise.reject(error);
    }
  );
};
